/**
 * Client-side analytics helper per Colucci Assicuratori.
 * Invia eventi di interazione al backend via `navigator.sendBeacon` (non bloccante).
 */

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "colucci_analytics_session";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = "s" + Math.random().toString(36).slice(2, 14) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return "s" + Math.random().toString(36).slice(2, 18);
  }
}

/**
 * Tracka un evento generico.
 * @param {string} event - Tipo: click | step_enter | step_exit | submit | error | success
 * @param {string} label - Identificatore (testid, step name, cta name)
 * @param {object} [opts] - { funnel, step, meta }
 */
export function trackEvent(event, label, opts = {}) {
  try {
    const payload = JSON.stringify({
      event,
      label: String(label || "").slice(0, 80),
      funnel: opts.funnel || null,
      step: opts.step || null,
      session_id: getSessionId(),
      path: window.location.pathname,
      meta: opts.meta || null,
    });
    const url = `${API}/track/event`;
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
        credentials: "omit",
      }).catch(() => {});
    }
  } catch {
    // silenzioso
  }
}

/** Shortcut per tracciare un click. */
export function trackClick(label, meta) {
  trackEvent("click", label, { meta });
}

/** Shortcut per entrare in uno step di funnel. */
export function trackStep(funnel, step, meta) {
  trackEvent("step_enter", `${funnel}:${step}`, { funnel, step, meta });
}

/** Shortcut per submit finale. */
export function trackSubmit(funnel, label, meta) {
  trackEvent("submit", label, { funnel, step: "submit", meta });
}
